import { oracleProjectSchema, oracleProjectsResponseSchema, } from '@consigli/types';
import { createTransformer } from './shared/base-api';
export const oracleApiEndpoints = (builder, coreApiBaseUrl) => ({
    searchOracleProjects: builder.query({
        query: ({ search }) => ({
            url: `${coreApiBaseUrl}/oracle/projects/`,
            method: 'GET',
            params: { search },
        }),
        extraOptions: { suppressErrorToast: true },
        transformResponse: createTransformer(oracleProjectsResponseSchema, 'SearchOracleProjects'),
    }),
    getOracleProject: builder.query({
        query: ({ projectNumber }) => ({
            url: `${coreApiBaseUrl}/oracle/projects/${projectNumber}/`,
            method: 'GET',
        }),
        extraOptions: { suppressErrorToast: true },
        transformResponse: createTransformer(oracleProjectSchema, 'GetOracleProject'),
    }),
});
